<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            PMPM Claims
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-billing-filter (searchEvent)="onSearch($event)" [filterFields]="fields"
                        [billingPageName]="'pmpmClaims'"></ppl-billing-filter>
                </div>
                <div class="table-style">
                    @if(claims.length > 0) {
                    <ppl-list-table [disableSearch]="true" [showCustomSearch]="false" [cols]="cols"
                        [enableActions]="true" [data]="claims" (rowDetailEvent)="rowClicked($event)"
                        (rowDetailEventTs)="rowActions($event)" [disableSelection]="true" [gridTitle]="false"
                        [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [customDataLoaded]="true" [from]="'billing'" (gridAction)="onAction($event)"
                        [actionButtons]="actionButtons">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>


<div class="filter-panel">
    <ng-template #viewCDRDialog let-cancel="cancel">
        <div>
            <ppl-list-table [pageConfig]="programName" [disableSearch]="true" [showCustomSearch]="false"
                [enableActions]="false" [data]="cdrData" [disableSelection]="true" [gridTitle]="false"
                [disableSort]="true" [pagination]="true" [loadPage]="false" [from]="'billing'"
                [jsonList]="'list_cdr_recon'">
            </ppl-list-table>
        </div>

    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #viewPaymentDialog let-cancel="cancel">
        <ppl-list-table [pageConfig]="programName" [disableSearch]="true" [showCustomSearch]="false"
            [enableActions]="false" [data]="paymentData" [disableSelection]="true" [gridTitle]="false"
            [disableSort]="true" [pagination]="true" [loadPage]="false" [from]="'billing'"
            [jsonList]="'list_billing_payment_recon'">
        </ppl-list-table>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #viewClaimReportDialog let-cancel="cancel">
        <ppl-claim-report [claimReportData]="claimReportData" [id]="id"></ppl-claim-report>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #resubDialog let-cancel="cancel">
        <p>Resub PPL ICN: <b>{{resubClaimId}}</b></p>
        <p>Resub Reason: <b>{{resubReason}}</b></p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #viewPdfDialog let-cancel="cancel">
        @if (pdfSrc && !pdfMessage) {
        <ngx-extended-pdf-viewer [src]="pdfSrc" [showToolbar]="false" useBrowserLocale="true" height="90vh">
        </ngx-extended-pdf-viewer>
        } @else {
        <div>
            <p>{{pdfMessage}}</p>
        </div>
        }
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #viewHierarchyDialog let-cancel="cancel">
        <div>
            <ppl-claim-hierarchy [hierarchyData]="hierarchyData"></ppl-claim-hierarchy>
        </div>
    </ng-template>
</div>